import React from 'react'

const HistoryIcon: React.FC = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="history">
        <path
          id="Vector"
          d="M22.4997 12C22.4997 6.20101 17.7987 1.5 11.9997 1.5C10.202 1.5 8.50695 1.95264 7.02538 2.75098C5.63074 3.50248 4.42555 4.56009 3.49974 5.83442V2.5H1.49975V9.5H8.49974V7.5H4.78715C5.56985 6.24843 6.6697 5.21451 7.9741 4.51164C9.17133 3.86651 10.5412 3.5 11.9997 3.5C16.6942 3.5 20.4997 7.30558 20.4997 12C20.4997 16.6944 16.6942 20.5 11.9997 20.5C7.60814 20.5 3.9933 17.1687 3.54632 12.896L3.44228 11.9014L1.45312 12.1095L1.55718 13.104C2.10959 18.3846 6.57341 22.5 11.9997 22.5C17.7987 22.5 22.4997 17.799 22.4997 12ZM10.9997 6V12.4142L14.4997 15.9142L15.914 14.5L12.9997 11.5858V6H10.9997Z"
          fill="#EDEBF7"
        />
      </g>
    </svg>
  )
}

export default HistoryIcon
